'use strict';

var GlobalNotifPanelDirective = function GlobalNotifPanelDirective($rootScope) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/global-notif-panel.html'),
    controller: require('../controllers/GlobalNotifPanelController'),
    link: function link($scope, element) {
      $scope.$on('brush-filter:filterApplied', function () {
        $rootScope.$broadcast('brush-filter:filterApplied:updateToolbar');
      });
      element.on('rowselect', $scope.rowSelectionChanged);
      element.on('rowunselect', $scope.rowSelectionChanged);
      element.on('show.bs.modal', function () {
        $scope.resetGridPanel();
      });
      element.on('hide.bs.modal', function () {
        $scope.clearSelection();
      });
      $scope.hidePanel = function () {
        element.modal('hide');
      };
    }
  };
};
GlobalNotifPanelDirective.$inject = ['$rootScope'];
module.exports = GlobalNotifPanelDirective;